import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

export function authenticateUser(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/getToken`, data)
        .then(res => (res && res?.data ? res.data : null))
}

export function authenticateUserWithSSO(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/socialAuth/ssoLogin`, data)
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getUserAuthData(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/authentication/getById`, {
            params: {userId, id: userId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function renewToken(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/renewToken`, data)
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function revokeToken(refreshToken) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/revokeToken`, null, {
            params: {refreshToken},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function validateCaptcha(response) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/captcha/validateCaptcha`, null, {
            params: {response},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function validateCloudFlareCaptcha(token) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/captcha/validateCloudFlareCaptcha`, {
            token: token,
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function sendVerificationCode(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/sendVerificationCode`, data)
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function checkVerificationCode(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/checkVerificationCode`, data)
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function checkVerificationCodeAsPassword(data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/authentication/checkVerificationCodeAsPassword`,
            data,
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function changePassword(data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/authentication/changePassword`, data)
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function checkQualifiedRole(userId, hospitalId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/userRole/checkQualifiedInHospital`, null, {
            params: {userId, hospitalId},
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
